module.exports = __webpack_public_path__ + "static/img/no-file.e6c1d2ac.png";